import {
  BUYER_GSTIN_LIST,
  CHECKED_CANCEL,
  CHECKED_CANCEL_PAYLOAD,
  CHECKED_IRN,
  CHECKED_IRN_NOT_GENERATED,
  CHECKED_IRN_NOT_GENERATED_PAYLOAD,
  CHECKED_IRN_PAYLOAD,
  EINV_ITEM_ERROR_DATA,
  GST_RES_TABLE_DATA,
  ITEM_LIST_DATA,
  LOADER_STATUS,
  PART_B_ERROR,
  PROFILE_DATA,
  RECEIPIENT_GSTIN_FILTER,
  SEARCH_STR,
  SELECTED,
  SELECTED_FROM_DATE,
  SELECTED_GSTIN,
  SELECTED_ROW,
  SELECTED_TO_DATE,
  STATUS_CODE,
  STATUS_CODE_CANCEL,
  STATUS_CODE_NOT_GEN,
  SUPPLIER_GSTIN_FILTER,
  TABLE_DATA,
  TOTAL_PAGES,
  TOTAL_RECORDS,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  tableData: [],
  searchStr: "",
  totalPages: 1,
  totalRecords: 0,
  selected: [],
  itemListData: [],
  einvItemErrorData: [],
  gstResTableData: [],
  checkedIrn: false,
  checkedCancel: false,
  profileData: [],
  selectedGstin: "",
  statusCode: "",
  statusCodeCancel: "",
  partBError: [],
  supplierGstinFilter: [],
  receipientGstinFilter: [],
  selectedFromDate: "",
  selectedToDate: "",
  checkedIrnNotGen: false,
  statusCodeNotGen: "",
  selectedRow: [],
  buyerGstinList: [],
};

/* eslint-disable default-case, no-param-reassign */
const EinvReducerNew = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case TABLE_DATA:
      return {
        ...state,
        tableData: action.tableData,
      };
    case SEARCH_STR:
      return {
        ...state,
        searchStr: action.searchStr,
      };
    case TOTAL_PAGES:
      return {
        ...state,
        totalPages: action.totalPages,
      };
    case TOTAL_RECORDS:
      return {
        ...state,
        totalRecords: action.totalRecords,
      };
    case SELECTED:
      return {
        ...state,
        selected: action.selected,
      };
    case ITEM_LIST_DATA:
      return {
        ...state,
        itemListData: action.itemListData,
      };
    case EINV_ITEM_ERROR_DATA:
      return {
        ...state,
        einvItemErrorData: action.einvItemErrorData,
      };
    case GST_RES_TABLE_DATA:
      return {
        ...state,
        gstResTableData: action.gstResTableData,
      };
    case CHECKED_CANCEL:
      return {
        ...state,
        checkedCancel: !state.checkedCancel,
      };
    case CHECKED_CANCEL_PAYLOAD:
      return {
        ...state,
        checkedCancel: action.checkedCancel,
      };
    case CHECKED_IRN:
      return {
        ...state,
        checkedIrn: !state.checkedIrn,
      };
    case CHECKED_IRN_PAYLOAD:
      return {
        ...state,
        checkedIrn: action.checkedIrn,
      };
    case PROFILE_DATA:
      return {
        ...state,
        profileData: action.profileData,
      };
    case SELECTED_GSTIN:
      return {
        ...state,
        selectedGstin: action.selectedGstin,
      };
    case STATUS_CODE:
      return {
        ...state,
        statusCode: action.statusCode,
      };
    case STATUS_CODE_CANCEL:
      return {
        ...state,
        statusCodeCancel: action.statusCodeCancel,
      };
    case STATUS_CODE_NOT_GEN:
      return {
        ...state,
        statusCodeNotGen: action.statusCodeNotGen,
      };
    case PART_B_ERROR:
      return {
        ...state,
        partBError: action.partBError,
      };
    case SUPPLIER_GSTIN_FILTER:
      return {
        ...state,
        supplierGstinFilter: action.supplierGstinFilter,
      };
    case RECEIPIENT_GSTIN_FILTER:
      return {
        ...state,
        receipientGstinFilter: action.receipientGstinFilter,
      };
    case SELECTED_FROM_DATE:
      return {
        ...state,
        selectedFromDate: action.selectedFromDate,
      };
    case SELECTED_TO_DATE:
      return {
        ...state,
        selectedToDate: action.selectedToDate,
      };
    case CHECKED_IRN_NOT_GENERATED:
      return {
        ...state,
        checkedIrnNotGen: !state.checkedIrnNotGen,
      };
    case CHECKED_IRN_NOT_GENERATED_PAYLOAD:
      return {
        ...state,
        checkedIrnNotGen: action.checkedIrnNotGen,
      };
    case SELECTED_ROW:
      return {
        ...state,
        selectedRow: action.selectedRow,
      };
    case BUYER_GSTIN_LIST:
      return {
        ...state,
        buyerGstinList: action.buyerGstinList,
      };
    default:
      return state;
  }
};

export default EinvReducerNew;
